import { render, staticRenderFns } from "./AddCompanyFileModal.vue?vue&type=template&id=0f6f1b2d&"
import script from "./AddCompanyFileModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports